package dk.smark.demo

import dk.smark.demo.location.GenericLocation
import dk.smark.demo.location.LocationResult
import dk.smark.demo.location.LocationService
import dk.smark.demo.location.ShareService
import dk.smark.demo.location.createLocationService
import dk.smark.demo.location.createShareService
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.launch
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

class MainViewModel {

    var viewModelScope = kotlinx.coroutines.CoroutineScope(kotlinx.coroutines.Dispatchers.Main)
    private var shareService: ShareService = createShareService()

    var locationService: LocationService = createLocationService()

    var isAdFree: Flow<Boolean> = flowOf(false)
    private val _lastKnownLocation = MutableStateFlow<GenericLocation?>(null)

    val lastKnownLocation: StateFlow<GenericLocation?> = _lastKnownLocation.asStateFlow()

    /** Call this proactively (e.g. on screen open) to pre-fetch location */
    fun fetchLocation() {
        viewModelScope.launch {
            when (val result = locationService.getCurrentLocation()) {
                is LocationResult.Success -> _lastKnownLocation.value = result.location
                is LocationResult.Error -> { /* handle error */ }
            }
        }
    }

    /** Call this directly from the button click handler — must not suspend before share */
    fun shareLocation() {
        val location = _lastKnownLocation.value
        if (location != null) {
            viewModelScope.launch {
                shareService.shareLocation(location)
            }
        } else {
            // Fallback: fetch and share, but this may fail on iOS due to gesture timeout
            viewModelScope.launch {
                when (val result = locationService.getCurrentLocation()) {
                    is LocationResult.Success -> {
                        _lastKnownLocation.value = result.location
                        shareService.shareLocation(result.location)
                    }
                    is LocationResult.Error -> { /* handle error */ }
                }
            }
        }
    }

    private val _locationTrack = MutableStateFlow<List<GenericLocation>>(emptyList())
    val locationTrack: StateFlow<List<GenericLocation>> = _locationTrack.asStateFlow()

    private var trackingJob: kotlinx.coroutines.Job? = null

    fun startTracking() {
        if (trackingJob?.isActive == true) return
        trackingJob = viewModelScope.launch {
            locationService.trackLocation().collect { result ->
                if (result is LocationResult.Success) {
                    _locationTrack.update { it + result.location }
                    _lastKnownLocation.value = result.location
                }
            }
        }
    }

    fun stopTracking() {
        trackingJob?.cancel()
        trackingJob = null
    }

    fun clearTrack() {
        _locationTrack.value = emptyList()
    }
}